import { render, staticRenderFns } from "./ListResellerInvoicePage.vue?vue&type=template&id=236ddbd2"
import script from "./ListResellerInvoicePage.vue?vue&type=script&lang=js"
export * from "./ListResellerInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports